import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class AdminCarrierAccountService {
	private baseUrl = environment.apiGateway.apiUrl;
	private adminCarrierAccountApiUrl = '';

	constructor() {
		this.adminCarrierAccountApiUrl = this.baseUrl + 'AdminCarrierAccount/';
	}

	/**
	 * Get CarrierAccounts For Admin
	 * @param appId
	 * @param cancelToken
	 */
	public async GetCarrierAccounts(appId: string, cancelToken: CancelToken): Promise<models.ICarrierAccounts[]> {
		try {
			const url = this.adminCarrierAccountApiUrl + appId;
			const res = await axios.get<models.ICarrierAccounts[]>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 * Delete CarrierAccount For Admin
	 * @param appId
	 * @param carrierId
	 * @param cancelToken
	 */
	public async DeleteCarrierAccountByAdmin(
		appId: string,
		carrierAcountId: string,
		cancelToken?: CancelToken
	): Promise<boolean> {
		try {
			const url = this.adminCarrierAccountApiUrl + `${carrierAcountId}`;
			const res = await axios.delete(url, {
				cancelToken,
				params: {
					appId,
				},
			});
			return res.data;
		} catch (err) {
			throw err;
		}
	}

	public async updateCarrierAccountConfigForAdmin(
		carrierId: string,
		data: models.IAdminCarrierAccountConfigData
	): Promise<any> {
		try {
			const url = this.adminCarrierAccountApiUrl + `${carrierId}/Configuration`;
			const res = await axios.put(url, data);

			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 * Get tier override configs
	 * @param carrierAccountId
	 * @param cancelToken
	 */
	public async GetTierOverrideCarrierAccountConfig(
		carrierAccountId: string,
		cancelToken?: CancelToken
	): Promise<models.ITierOverrideConfigs> {
		try {
			const url = this.adminCarrierAccountApiUrl + `${carrierAccountId}/OverrideConfigs`;
			const res = await axios.get(url, {
				cancelToken,
			});
			return res.data;
		} catch (err) {
			throw err;
		}
	}

	/**
	 * Upsert tier override configs
	 * @param carrierAccountId
	 * @param tierOverrideConfigs
	 * @param cancelToken
	 */
	public async UpsertTierOverrideCarrierAccountConfig(
		carrierAccountId: string,
		tierOverrideConfigs: models.ITierOverrideConfigs,
		cancelToken?: CancelToken
	): Promise<models.ITierOverrideConfigs> {
		try {
			const url = this.adminCarrierAccountApiUrl + `${carrierAccountId}/OverrideConfigs`;
			const res = await axios.put(url, tierOverrideConfigs, {
				cancelToken,
			});
			return res.data;
		} catch (err) {
			throw err;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/admin-carrier-account.service.ts